export class QuotesTabs {
    public static IncomingQuotes : number = 0;
    public static OutgoingQuotes : number = 1;
}